import { DateFilter } from '@features/campaigns/components/DateFilter';
import { Header } from './Header';
import { TabView } from './TabView';
import { OptimizationsDialog } from './OptimizationsDialog';
import { LciReportDialog } from './LciReportDialog';
import { FlexibleReportingDialog } from './FlexibleReportingDialog';
import { useCurrentReport } from '../hooks';
import { DetailsProps } from '@features/campaigns/components/CampaignLayout';
import { AdSpendChip } from './AdSpendChip';
import { CampaignContext } from '@features/campaigns/stores/campaign-context';
import { useReducer } from 'react';
import { initialState, reducer } from '@features/campaigns/stores/reducer';

export const Details = (props: DetailsProps) => {
  const { report } = useCurrentReport();
  const [campaignState, dispatch] = useReducer(reducer, initialState);

  return (
    <CampaignContext.Provider value={{ state: campaignState, dispatch }}>
      <OptimizationsDialog />
      <LciReportDialog />
      <FlexibleReportingDialog />
      <Header campaignName={props.campaignName} />
      <DateFilter
        campaignId={props.campaignId}
        endReportDates={props.reportDates}
        measurementStartDate={report?.startDate ?? props.campaignStartDate}
        campaignEndDate={props.campaignEndDate}
        channels={props.channels}
      >
        <AdSpendChip />
      </DateFilter>
      <TabView campaignId={props.campaignId} />
    </CampaignContext.Provider>
  );
};
